import { render } from "./AppointmentViewModal.vue?vue&type=template&id=5b024205&scoped=true"
import script from "./AppointmentViewModal.vue?vue&type=script&lang=js"
export * from "./AppointmentViewModal.vue?vue&type=script&lang=js"

import "./AppointmentViewModal.vue?vue&type=style&index=0&id=5b024205&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b024205"]])

export default __exports__